<app-header></app-header>
<router-outlet></router-outlet>
<!-- <ngx-spinner><p style="color: white" ></p></ngx-spinner> -->
<app-footer></app-footer>